import React, { useState, useEffect, ReactNode } from 'react';

interface DotDotDotProps {
  children: (addDots: (enable?: boolean) => ReactNode) => ReactNode;
  interval?: number; // Optional interval in milliseconds
}

export const DotDotDot: React.FC<DotDotDotProps> = ({ children, interval = 400 }) => {
  const dotCounts = [0, 1, 2, 3, 3];
  const [sequenceIndex, setSequenceIndex] = useState(0);

  useEffect(() => {
    const timerId = setInterval(() => {
      setSequenceIndex((prevIndex) => (prevIndex + 1) % dotCounts.length);
    }, interval);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(timerId);
  }, [interval, dotCounts.length]); // Re-run effect if interval or sequence length changes

  const addDots = (enable: boolean = true): ReactNode => {
    if (!enable) {
      return null; // Return nothing if not enabled
    }
    const maxDots = 3; // Maximum number of dots based on dotCounts
    const visibleDotsCount = dotCounts[sequenceIndex];
    const invisibleDotsCount = maxDots - visibleDotsCount;

    const visibleDots = '.'.repeat(visibleDotsCount);
    const invisibleDots = '.'.repeat(invisibleDotsCount);

    return (
      <>
        {visibleDots}
        {invisibleDotsCount > 0 && (
          <span style={{ visibility: 'hidden' }}>{invisibleDots}</span>
        )}
      </>
    );
  };

  // Call the children function prop, passing the addDots function
  return <>{children(addDots)}</>;
};
